import { InjectionToken } from '@angular/core';

export namespace NPca {
    export const DEFAULT_OPTIONS: IModuleOptions = {
        company: false
    };

    export const OPTIONS = new InjectionToken<IModuleOptions>('DF_PCA_OPTIONS', {
        providedIn: 'root',
        factory: () => DEFAULT_OPTIONS
    });

    export interface IModuleOptions {
        company?: boolean;
    }
}
